// @flow

import React, { type Node } from 'react';
import { Box } from 'gestalt';

type Props = {
  children?: Node,
  itemWidth?: number | string,
  maxColumns?: number,
};

const generatePlaceholders = (itemWidth, length) =>
  Array.from(new Array(length)).map((item, index) => <Box key={index} width={itemWidth} />);

/**
 * Allows flexbox to perfectly center content on a page while still maintaining left alignment on
 * each subsequent row by padding empty divs at the end of the content.
 *
 * Default behavior assumes maximum of 12 items per row and will pad with 12 empty divs.  The divs must be
 * given the same width as each individual item in the row.
 */
function ProfileGridLayout({ children, itemWidth, maxColumns = 12 }: Props) {
  return (
    <Box display="flex" justifyContent="center" wrap>
      {children}
      {generatePlaceholders(itemWidth, maxColumns)}
    </Box>
  );
}

export default ProfileGridLayout;
